import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Collection from 'routes/Products/components/Collection';

class CollectionPage extends PureComponent {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return <Collection customTitle="Custom Title" {...this.props} />;
  }
}

CollectionPage.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  Children: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  data: PropTypes.shape({}).isRequired
};

export default CollectionPage;
